// extracted by mini-css-extract-plugin
export default {"PostCreate":"qh_a bhp_qt bhp_a bhp_w bhp_ea"};